<template>
  <validation-observer
    ref="createAccountForm"
    #default="{ invalid }"
  >
    <b-modal
      id="create-account-modal"
      :title="$t('Account info')"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="submit"
      @hidden="hideModal"
      @show="serviceChange(form.service_id)"
    >
      <b-form>
        <b-form-group
          :label="$t('Account name')"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('Account name')"
            vid="name"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="form.name"
              type="text"
              :state="errors.length > 0 ? false : null"
              :placeholder="$t('Account name')"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group :label="$t('Service')">
          <validation-provider
            #default="{ errors }"
            :name="$t('Service')"
            vid="type"
            rules="required"
          >
            <v-select
              v-model="form.service_id"
              :options="services"
              :clearable="false"
              :reduce="_service => _service.id"
              :state="errors.length > 0 ? false : null"
              label="name"
              @input="serviceChange"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group :label="$t('Account type')">
          <validation-provider
            #default="{ errors }"
            :name="$t('Account type')"
            vid="type"
            rules="required"
          >
            <v-select
              v-model="form.type"
              :options="accountTypes"
              :clearable="false"
              :reduce="_type => _type.key"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-form>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'

export default {
  name: 'CreateAccountModal',
  components: {

  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      accountTypes: [],
    }
  },
  methods: {
    submit(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.$refs.createAccountForm.validate().then(success => {
        if (success) {
          this.loading = true
          this.$http
            .post('/accounts', this.form)
            .then(({ data }) => this.$router.push({
              name: 'accounts-show',
              params: { id: data.id },
            }))
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    serviceChange(serviceId) {
      const service = this.services.find(value => value.id.toString() === serviceId.toString())
      this.accountTypes = service.accountTypes
      this.form.type = this.accountTypes[0].key
    },
  },
}
</script>

<style scoped>

</style>
